import React, { useEffect } from "react";
import {useLocation, useNavigate} from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token_url = query.get("token");
  const email = query.get("email");
  console.log("token: ", token_url);
  console.log("email: ", email);

  useEffect(() => {
    console.log("token: ", token_url);
    console.log("email: ", email);
    if(token_url){
      navigate("/reset_password?token=" + token_url + "&email=" + email);
    } else if (window.localStorage.getItem("auth_token") === null) {
      navigate("/login");
    } else {
      if (window.localStorage.getItem("authority") === "ADMIN") {
        navigate("/dashboard_admin");
      } else if (window.localStorage.getItem("authority") === "DOCTOR") {
        navigate("/patients");
      }
    }

    const authority = window.localStorage.getItem("authority");
    const name = window.localStorage.getItem("name");
    const surname = window.localStorage.getItem("surname");
    const token = window.localStorage.getItem("auth_token");

    console.log("authority: ", authority);
    console.log("name: ", name);
    console.log("surname: ", surname);
    console.log("token: ", token);
  }, [navigate]);

  return <div className="login-container"></div>;
};

export default Home;
